<template>
  <div class="receive-address">
    <div class="flex-between">
      <div class="subtitle">常用收货地址</div>
      <div class="add-address pointer">
        <img src="@/assets/images/add-address.png" />
        <span @click="handleAdd">新增收货地址</span>
      </div>
    </div>
    <div v-if="addressList.length > 0" class="address-list">
      <div class="address-info" :class="[(index+1) % 3 === 0 ? 'mr0' : '', item.isDefault ? 'active' : '']" v-for="(item, index) in addressList" :key="index">
        <div class="line1">
          <span class="name">{{item.consignee}}</span>
          <span>{{item.phone}}</span>
        </div>
        <div class="line2">{{item.areaName}}</div>
        <div class="line3">{{item.address}}</div>
        <div class="line4">
          <div class="left">
            <el-switch
              v-model="item.isDefault"
              @change="handleSetDefault(item)"
              active-color="#9B232A"
              inactive-color="#A7AEBB">
            </el-switch>
            <span>默认收货地址</span>
          </div>
          <div class="right">
            <span class="pointer" @click="handleDelete(item.id)">删除</span>
            <span class="pointer" @click="handleUpdate(item)">修改</span>
          </div>
        </div>
      </div>

    </div>
    <div v-else class="nodata">暂无数据</div>
    <el-dialog
      :modal-append-to-body="false"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="560px"
      @close="handleCancel('dialogForm')"
    >
      <el-form :model="dialogForm" ref="dialogForm" label-width="100px">
        <el-form-item
          prop="consignee"
          label="收货人："
          :rules="[{required: true, message: '请输入收货人姓名', trigger: ['blur', 'change']}]">
          <el-input clearable class="w80" placeholder="请输入收货人姓名" v-model="dialogForm.consignee"></el-input>
        </el-form-item>
        <el-form-item
          prop="phone"
          label="手机号："
          :rules="[{ required: true, validator: checkPhone }]">
          <el-input clearable class="w80" placeholder="请输入收货人手机号" v-model="dialogForm.phone"></el-input>
        </el-form-item>
        <el-form-item
          prop="areaId"
          label="所在地区："
          :rules="[{required: true, message: '请选择省-市-区-街道', trigger: ['blur', 'change']}]">
          <el-cascader clearable placeholder="请选择省-市-区-街道" :options="areaOptions" :props="{ value: 'id', label: 'name' }" v-model="dialogForm.areaId"></el-cascader>
        </el-form-item>
        <el-form-item
          class="mb10"
          prop="address"
          label="收货地址："
          :rules="[{required: true, message: '请输入详细地址', trigger: ['blur', 'change']}]">
          <el-input clearable class="w80" placeholder="请输入详细地址" v-model="dialogForm.address"></el-input>
        </el-form-item>
        <el-form-item
          prop="isDefault"
          label=""
          >
          <el-checkbox text-color="#9B232A" v-model="dialogForm.isDefault">设为常用收货地址</el-checkbox>
        </el-form-item>
        <div class="btn">
          <div class="btn-cancle" @click="handleCancel('dialogForm')">取消</div>
          <div class="btn-save" @click="handleSave('dialogForm')">确定</div>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getAddressList, saveObj, deleteObj } from '@/api/receiveAddress'
import { validaCellPhone } from '@/utils/validate'
import { getAreaStr, getAreaStr1 } from '@/common/js/utils'

export default {
  data () {
    return {
      addressList: [],
      dialogVisible: false,
      dialogTitle: '添加地址',
      dialogForm: {
        isDefault: false
      },
      areaOptions: []
    }
  },
  created () {
    this.areaOptions = this.$store.state.areaList || []
    this.getAddressList()
  },
  methods: {
    checkPhone (rule, value, callback) {
      if (value) {
        if (validaCellPhone(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      } else {
        callback(new Error('请输入收货人手机号'))
      }
    },
    handleAdd () {
      this.dialogTitle = '添加地址'
      this.dialogForm = {
        isDefault: false
      }
      this.dialogVisible = true
    },
    handleUpdate (item) {
      this.dialogTitle = '修改地址'
      this.dialogForm = JSON.parse(JSON.stringify(item))
      this.dialogVisible = true
    },
    handleSetDefault (item) {
      const data = {
        id: item.id,
        isDefault: item.isDefault
      }
      saveObj(data).then((res) => {
        if (res.code === 0) {
          this.$message.success('修改成功')
          this.getAddressList()
        } else {
          this.$message.error(res.error)
        }
      })
    },
    handleDelete (id) {
      this.$confirm('确认删除该收货地址', '提示', {
        type: 'warning',
        confirmButtonText: '确定'
      }).then(() => {
        deleteObj(id).then(res => {
          if (res.code === 0) {
            this.$message.success('删除成功')
            this.getAddressList()
          } else {
            this.$message.error(res.error)
          }
        })
      })
    },
    handleSave (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const data = JSON.parse(JSON.stringify(this.dialogForm))
          data.areaName = getAreaStr1(this.dialogForm.areaId[0], this.dialogForm.areaId[1], this.dialogForm.areaId[2])
          data.areaId = data.areaId.join()
          saveObj(data).then((res) => {
            if (res.code === 0) {
              this.$message.success(data.id ? '修改成功' : '添加成功')
              this.dialogVisible = false
              this.getAddressList()
            } else {
              this.$message.error(res.error)
            }
          })
        }
      })
    },
    handleCancel (formName) {
      this.$refs[formName].resetFields()
      this.dialogVisible = false
      this.dialogForm = {}
    },
    getAddressList () {
      getAddressList().then((res) => {
        if (res.code === 0) {
          this.addressList = res.data.map(val => {
            val.areaId = val.areaId.split(',')
            val.areaName = getAreaStr(val.areaId[0], val.areaId[1], val.areaId[2])
            return val
          })
        } else {
          this.$message.error(res.error)
        }
      })
    }
  }
}
</script>

<style lang="scss">
.el-cascader-panel {
  max-height: 200px;
}
</style>

<style scoped lang='scss'>
.receive-address {
  padding: 40px;
  /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #9B232A;
    border-color: #9B232A;
  }
  /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #9B232A;
  }
  .mb10{
    margin-bottom: 10px;
  }
  .w80 {
    width: 80%;
  }
  .btn {
    justify-content: center;
    display: flex;
    cursor: pointer;
  }
  .btn-cancle {
    width: 140px;
    height: 44px;
    border: 1px solid #9b232a;
    text-align: center;
    line-height: 44px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #9b232a;
  }
  .btn-save {
    width: 140px;
    height: 44px;
    background: #9b232a;
    text-align: center;
    line-height: 44px;
    margin-left: 32px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #fff;
  }
  .subtitle {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 26px;
    color: #9b232a;
  }
  .add-address{
    border: 1px solid #9B232A;
    border-radius: 4px;
    padding: 4px 24px;
    display: flex;
    align-items: center;
    img{
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
    span{
      font-size: 16px;
      color: #9B232A;
    }
  }
  .nodata{
    margin-top: 100px;
    text-align: center;
  }
  .address-list{
    // display: flex;
    // justify-content: space-between;
    margin-top: 40px;
    .active {
      border: 1px solid #9B232A !important;
    }
    .mr0{
      margin-right: 0 !important;
    }
    .address-info{
      width: 27%;
      border-radius: 8px;
      padding: 20px;
      color: #242B34;
      font-size: 14px;
      margin-right: 24px;
      float: left;
      margin-bottom: 20px;
      border: 1px solid #BEC9DF;
      .line1{
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #242B34;
        .name{
          font-size: 16px;
          font-weight: bold;
        }
      }
      .line2{
        margin-top: 16px;
      }
      .line3{
        color: #9FA1B0;
        margin-top: 8px;
        line-height: 19px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .line4{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;
        span{
          font-size: 12px;
          margin-left: 8px;
        }
        .right{
          font-size: 14px;
          color: #9B232A;
        }
      }
    }
  }
}
</style>
